import React from "react";

function NotificationDescription({ html }) {
  return (
    <p
      dangerouslySetInnerHTML={{ __html: html }}
      style={{
        color: "black",
        margin: "0px",
        padding: "10px",
        wordWrap: "break-word",
      }}
    />
  );
}

NotificationDescription.propTypes = {};

export default NotificationDescription;
